import React from 'react';
import classNames from 'classnames';
import './ResolvedAnchorValue.less';

export interface IResolvedAnchorValueProps extends Omit<React.HTMLProps<HTMLDivElement>, 'children'> {
  resolvedText: string;
}

const getClassName = (className?: string) => classNames('dpc-resolved-anchor-value', className);

/**
 * Shows resolved anchor value on surface if it is possible to calculate in design time
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ResolvedAnchorValue({ resolvedText, className, ...otherProps }: IResolvedAnchorValueProps) {
  return (
    <div className={getClassName(className)} title={resolvedText} {...otherProps}>
      <span className="dpc-resolved-anchor-value__text">{resolvedText || ''}</span>
    </div>
  );
}
